
export default function shorten(addr) {
  return addr ? addr.slice(0, 6) + '...' + addr.slice(-6) : addr;
}
